
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/home-team-tailgate-2024",
      function () {
        return require("private-next-pages/events/home-team-tailgate-2024.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/home-team-tailgate-2024"])
      });
    }
  